import { CompensationCalculator } from "components";
import type { CompensationCalculatorProps } from "components/CompensationCalculator";
import type { ReactStoryblokComponent } from "types/storyblok";

export const CompensationCalculatorAdapter = ({
  blok,
  sbEditable,
}: ReactStoryblokComponent<CompensationCalculatorProps>) => (
  <CompensationCalculator {...blok} sbEditable={sbEditable} />
);
